import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/js/dist/modal";
import React, { useEffect, useState } from "react";
import { fetchApiPost, fetchApiGet } from "./utils/FetchApi";
import { ApiName } from "./Constant/ApiName";
import AllRoutes from "./Routes/AllRoutes";
import TagManager from "react-gtm-module";
import { decode as base64_decode } from "base-64";
import moment from "moment";
import { clearUserSession, getCookie, setCookie } from "./utils/CommonFunction";
import { useNavigate } from "react-router-dom";

declare global {
  var authToken: string;
}

function App() {
  const navigate = useNavigate();
  // State
  const [jwtToken, setJwtToken] = useState<string | null>(null);
  const [isSubscribe, setIsSubscribe] = useState(false);
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-5JFD9W2K",
    };

    TagManager.initialize(tagManagerArgs);
    const data = getCookie("data");
    if (jwtToken === null) {
      handleGenerateJwtToken();
    } else if (data?.msisdn) {
      handleCheckUser(data);
    }
  }, [jwtToken]);

  // function
  const handleGenerateJwtToken = async () => {
    try {
      let data: any = {
        username: process.env.REACT_APP_UserName,
        password: process.env.REACT_APP_Password,
      };
      const response = await fetchApiPost(null, ApiName.generateGwtToken, data);

      if (response.status === 200) {
        setJwtToken(response.access_token);
        global.authToken = response.access_token;
      }
    } catch (error) {
      console.log("Jwt token" + error);
    }
  };
  const handleCheckUser = (data: any) => {
    if (
      (typeof document !== "undefined" &&
        document.referrer === "http://digital.jazzjobup.com.pk/") ||
      document.referrer === "https://digital.jazzjobup.com.pk/"
    ) {
      const { pathname, href, search } = window.location;
      const urlParams = new URLSearchParams(search);
      const hasRequiredParams =
        href.includes("?") &&
        urlParams.has("user") &&
        urlParams.has("package") &&
        urlParams.has("token");

      if (pathname === "/home" && hasRequiredParams) {
        let msisdn = base64_decode(urlParams.get("user") || "");
        let packageDetail = base64_decode(urlParams.get("package") || "");
        let token = base64_decode(urlParams.get("token") || "");

        if (msisdn.length === 10) {
          setCookie(msisdn, packageDetail, token);
          global.authToken = token;
          setIsSubscribe(true);
          navigate("/");
        }
      }
    } else if (data?.msisdn) {
      setIsSubscribe(true);
      const packageChangeTime = localStorage.getItem("packageChangeTime");

      if (
        !packageChangeTime ||
        moment().diff(moment(packageChangeTime), "minutes") > 30
      ) {
        handleCheckUserApiCall(data?.msisdn);
      }
    }
  };

  const handleCheckUserApiCall = async (msisdn: any) => {
    try {
      let endPoint = ApiName.checkUser + msisdn;
      let response = await fetchApiGet(jwtToken, endPoint);
      if (response.status === 200) {
        if (response.results.desc.toLowerCase() === "inactive") {
          clearUserSession();
          setIsSubscribe(false);
        } else {
          setIsSubscribe(true);
        }
      } else {
        setIsSubscribe(false);
      }
    } catch (error) {
      console.log("check user" + error);
      setIsSubscribe(false);
    }
  };

  const handleLogout = () => {
    clearUserSession();
    setIsSubscribe(false);
    window.location.replace(
      window.location.origin + "/landingjazzcash?plan_id=7",
    );
  };

  const handleUnSubscribe = async () => {
    try {
      setLoader(true);
      const data = getCookie("data");

      let endPoint = ApiName.unSubscribeWeb + data.msisdn;
      let response = await fetchApiGet(jwtToken, endPoint);
      if (response.status === 200 && response.results.code) {
        clearUserSession();
        setIsSubscribe(false);
        window.location.replace(
          window.location.origin + "/landingjazzcash?plan_id=7",
        );
      } else {
        setLoader(false);
        setErrorMsg("Unable to Unsubscribe, Please try again");
      }
    } catch (error) {
      setLoader(false);
      console.log("Unsubscribe error" + error);
      setErrorMsg("Something went wrong, Please try again");
    }
  };

  return (
    <>
      <AllRoutes
        jwtToken={jwtToken}
        isSubscribe={isSubscribe}
        handleLogout={handleLogout}
        handleUnSubscribe={handleUnSubscribe}
        loader={loader}
        errorMsg={errorMsg}
      />
    </>
  );
}

export default App;
